// extracted by mini-css-extract-plugin
module.exports = {"layout":"offset-callout_layout__hPoxl","content":"offset-callout_content__dOnkL","image":"offset-callout_image__yZ6Jn"};